import * as React from 'react';
import { Link } from 'react-router-dom';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { Routes } from '../../../../utils/app-constants';
import { toLocalDateString, toSlashedShortDate } from '../../../../utils/date-utils';
import { ContainerSummary } from '../../../../transportation/models/containers/_index';
import { ShipmentStatusMetadata } from '../../../../transportation/models/enums/shipment-status';

// #region Component Props

interface IProps extends TSelectableItemProps {
    container       : ContainerSummary;
}

// #endregion

const ContainerRow = (props: IProps) => {

    const { selectableRef,
        isSelected,
        isSelecting
    } = props;

    let actualClass = 'order-selectable';
    actualClass += (props.container.isChecked) ? ' highlight' : '';
    actualClass += (isSelecting) ? ' dragging' : '';
    actualClass += (isSelected) ? ' selected-already' : '';

    return <tr
        ref={ selectableRef }
        className={`container-row ${ actualClass }`}>
        <td>
            <Link
                className="punchthrough"
                to={ Routes.SHIPPING_CONTAINER_EDIT_WITH_ID.formattify(props.container.id) }>
                { props.container.id }
            </Link>
        </td>
        <td>
            <span className={ "text-uppercase shipment-status-color " + ShipmentStatusMetadata[props.container.status].class }>
                { ShipmentStatusMetadata[props.container.status].display }
            </span>
        </td>
        <td>{ props.container.name }</td>
        <td>{ props.container.cutoffDate ? toSlashedShortDate(props.container.cutoffDate) : '' }</td>
        <td>
            {
                props.container.departureTime
                    ? toLocalDateString(props.container.departureTime.local, props.container.departureTime.timeZone)
                    : ''
            }
        </td>
    </tr>;
};

export default createSelectable<{ container : ContainerSummary }>(ContainerRow);
